import { useMemo } from 'react';
import { createPaymentsClient, type PaymentsClient } from '../api/paymentsClient.js';
import { useAuth } from '../auth/AuthContext.js';

/**
 * Bind a single {@link PaymentsClient} to the current auth session, mirroring {@link useShowClient}.
 * The client reads the access token through the getter on each request (§32.3).
 */
export function usePaymentsClient(): PaymentsClient {
  const { getAccessToken } = useAuth();
  return useMemo(() => createPaymentsClient(getAccessToken), [getAccessToken]);
}
